class PredictiveSearch extends HTMLElement {
    constructor() {
        super(),
            (this.cachedResults = {}),
            (this.input = this.querySelector('input[type="search"]')),
            (this.predictiveSearchResults = this.querySelector("[data-predictive-search]")),
            (this.trendingAndProductsBlock = this.querySelector("[data-quick-trending-products]")),
            (this.closeStickySearchButton = document.querySelector(".header-search-close")),
            (this.productToShow = this.dataset.productToShow),
            (this.searchDetails = this.querySelector(".search_details")),
            (this.predictiveSearch = this.querySelector("predictive-search")),
            (this.isOpen = !1),
            (this.quickSearchTrending = this.querySelectorAll(".quickSearchTrending .link")),
            (this.searchResultsWidget = this.getElementsByClassName("quickSearchResultsWidget")[0]),
            this.setupEventListeners(),
            this.quickSearchTrending.forEach((e) => {
                e.addEventListener("click", this.quickSearchTrendingClick.bind(this));
            });
    }
    setupEventListeners() {
        this.querySelector("form.search").addEventListener("submit", this.onFormSubmit.bind(this)),
            this.input.addEventListener(
                "input",
                debounce((e) => {
                    this.onChange(e);
                }, 500).bind(this)
            ),
            this.input.addEventListener("focus", this.onFocus.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.addEventListener("keyup", this.onKeyup.bind(this)),
            this.addEventListener("keydown", this.onKeydown.bind(this)),
            document.addEventListener("click", this.onDocClick.bind(this)),
            null != this.closeStickySearchButton &&
                this.closeStickySearchButton.addEventListener("click", this.onCloseStickySearchClick.bind(this)),
            this.input.addEventListener("click", this.doBeforeQuickSearchProduct.bind(this)),
            window.innerWidth <= 1024 &&
                document.querySelector("[data-search-mobile]") &&
                document.querySelectorAll("[data-search-mobile]").forEach((e) => {
                    e.addEventListener("click", this.doBeforeQuickSearchProduct.bind(this));
                });
    }
    doBeforeQuickSearchProduct() {
        this.renderQuickSearchProductBlock();
    }
    renderQuickSearchProductBlock() {
        if (!this.searchResultsWidget.classList.contains("ajax-loaded")) {
            const e = this.searchResultsWidget.querySelector(".quickSearchProduct");
            let t = e?.getAttribute("data-collection"),
                s = e?.getAttribute("data-limit"),
                i = "list-result-block";
            if (null != t && null != t)
                $.ajax({
                    type: "GET",
                    url: window.routes.root + "/collections/" + t,
                    cache: !1,
                    data: { view: "ajax_product_block", constraint: `limit=${s}+sectionId=${i}` },
                    beforeSend: () => {
                        e.closest(".quickSearchResultsWidget").classList.add("ajax-loaded");
                    },
                    success: (i) => {
                        if ("" != t) {
                            const t = this.handleResponse(i, s);
                            e.querySelector(".products-grid").innerHTML = t;
                        }
                        window.sharedFunctions?.swapHoverVideoProductCard();
                    },
                    complete: () => {
                        if (
                            (window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) ||
                            window.show_auto_currency
                        ) {
                            let e = document
                                .getElementById("currencies")
                                ?.querySelector(".active")
                                ?.getAttribute("data-currency");
                            Currency.convertAll(window.shop_currency, e, "span.money", "money_format");
                        }
                    },
                });
            else if (
                (this.searchResultsWidget.classList.add("ajax-loaded"),
                (window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) ||
                    window.show_auto_currency)
            ) {
                let e = document.getElementById("currencies")?.querySelector(".active")?.getAttribute("data-currency");
                Currency.convertAll(window.shop_currency, e, "span.money", "money_format");
            }
        }
    }
    handleResponse(e, t) {
        let s = document.createElement("div");
        return (
            (s.innerHTML = e),
            $(s)
                .find(`.product:nth-child(n+${Number(t) + 1})`)
                .remove(),
            $(s).html()
        );
    }
    getQuery() {
        return this.input.value.trim();
    }
    onChange() {
        const e = this.getQuery();
        e.length ? this.getSearchResults(e) : this.close(!0);
    }
    onFormSubmit(e) {
        (this.getQuery().length && !this.querySelector('[aria-selected="true"] a')) || e.preventDefault();
    }
    onFocus() {
        const e = this.getQuery();
        if (!e.length) return this.showTrendingAndProducts();
        "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(e);
    }
    onFocusOut() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close();
        });
    }
    onKeyup(e) {
        switch (
            (this.getQuery().length || (this.close(!0), this.showTrendingAndProducts()), e.preventDefault(), e.code)
        ) {
            case "ArrowUp":
                this.switchOption("up");
                break;
            case "ArrowDown":
                this.switchOption("down");
                break;
            case "Enter":
                this.selectOption();
        }
    }
    onKeydown(e) {
        ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
    }
    switchOption(e) {
        if (!this.getAttribute("open")) return;
        const t = "up" === e,
            s = this.querySelector('[aria-selected="true"]'),
            i = this.querySelectorAll("li");
        let r = this.querySelector("li");
        (t && !s) ||
            ((this.statusElement.textContent = ""),
            !t && s ? (r = s.nextElementSibling || i[0]) : t && (r = s.previousElementSibling || i[i.length - 1]),
            r !== s &&
                (r.setAttribute("aria-selected", !0),
                s && s.setAttribute("aria-selected", !1),
                this.setLiveRegionText(r.textContent),
                this.input.setAttribute("aria-activedescendant", r.id)));
    }
    selectOption() {
        const e = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
        e && e.click();
    }
    getSearchResults(e) {
        const t = e.replace(" ", "-").toLowerCase();
        if ((this.setLiveRegionLoadingState(), this.cachedResults[t]))
            return this.renderSearchResults(this.cachedResults[t]), void this.updateViewAllLink(e);
        fetch(
            `${routes.predictive_search_url}?q=${encodeURIComponent(e)}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent("resources[limit]")}=${this.productToShow}&section_id=predictive-search`
        )
            .then((e) => {
                if (!e.ok) {
                    var t = new Error(e.status);
                    throw (this.close(), t);
                }
                return e.text();
            })
            .then((s) => {
                const i = new DOMParser()
                    .parseFromString(s, "text/html")
                    .querySelector("#shopify-section-predictive-search").innerHTML;
                (this.cachedResults[t] = i), this.renderSearchResults(i), this.updateViewAllLink(e);
            })
            .catch((e) => {
                throw (this.close(), e);
            });
    }
    setLiveRegionLoadingState() {
        (this.statusElement = this.statusElement || this.querySelector(".predictive-search-status")),
            (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
            this.setLiveRegionText(this.loadingText),
            this.setAttribute("loading", !0);
    }
    setLiveRegionText(e) {
        this.statusElement.setAttribute("aria-hidden", "false"),
            (this.statusElement.textContent = e),
            setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true");
            }, 1e3);
    }
    renderSearchResults(e) {
        (this.predictiveSearchResults.innerHTML = e),
            this.setAttribute("results", !0),
            this.setAttribute("open", !0),
            this.setLiveRegionResults(),
            this.open(),
            this.hideTrendingAndProducts(),
            ((window.show_multiple_currencies &&
                "undefined" != typeof Currency &&
                Currency.currentCurrency != shopCurrency) ||
                window.show_auto_currency) &&
                Currency.convertAll(
                    window.shop_currency,
                    $("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                ),
            window.sharedFunctions?.swapHoverVideoProductCard();
    }
    setLiveRegionResults() {
        this.removeAttribute("loading"),
            this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
    }
    getResultsMaxHeight() {
        return (
            (this.resultsMaxHeight =
                window.innerHeight -
                document.querySelector('[class^="header-navigation"]').getBoundingClientRect().bottom),
            this.resultsMaxHeight
        );
    }
    open() {
        this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0);
    }
    close(e = !1) {
        e && ((this.input.value = ""), this.removeAttribute("results"));
        const t = this.querySelector('[aria-selected="true"]');
        t && t.setAttribute("aria-selected", !1),
            this.input.setAttribute("aria-activedescendant", ""),
            this.removeAttribute("open"),
            this.input.setAttribute("aria-expanded", !1),
            (this.resultsMaxHeight = !1),
            this.predictiveSearchResults.removeAttribute("style"),
            (this.isOpen = !1);
    }
    showTrendingAndProducts() {
        this.trendingAndProductsBlock &&
            (this.trendingAndProductsBlock.classList.add("is-show"),
            this.trendingAndProductsBlock.classList.remove("hidden"));
    }
    hideTrendingAndProducts() {
        this.trendingAndProductsBlock &&
            (this.trendingAndProductsBlock.classList.remove("is-show"),
            this.trendingAndProductsBlock.classList.add("hidden"));
    }
    onDocClick(e) {
        const t = this.contains(e.target),
            s = e.target;
        (!t ||
            s.closest(".header-search-popup-close") ||
            s.matches(".header-search-popup-close") ||
            s.closest(".header-search-close") ||
            s.matches(".header-search-close")) &&
            (this.close(), this.hideTrendingAndProducts());
    }
    onCloseStickySearchClick() {
        this.close(),
            this.hideTrendingAndProducts(),
            document.querySelector("body").classList.remove("sticky-search-open"),
            document.querySelector("body").classList.remove("sticky-search-menu-open"),
            this.closest('[class*="section-header-"]')?.classList.remove("sticky-search-menu-open"),
            this.closest('[class*="section-header-"]')?.classList.remove("sticky-search-menu-custom-open");
    }
    updateViewAllLink(e) {
        const t = document.querySelector("[data-qs-view-all-link]");
        if (!t) return;
        const s = `${routes.search_url}?q=${encodeURIComponent(e)}&options%5Bprefix%5D=last&type=product`;
        return (
            (t.href = s),
            this.getTotalResults(s).then((e) => {
                t.innerHTML = t.innerHTML.replace("()", `(${e})`);
            })
        );
    }
    getTotalResults(e) {
        return fetch(e)
            .then((e) => {
                if (!e.ok) {
                    var t = new Error(e.status);
                    throw (this.close(), t);
                }
                return e.text();
            })
            .then(
                (e) =>
                    new DOMParser().parseFromString(e, "text/html").querySelector('[id^="SearchSection"]').dataset
                        .searchCount
            )
            .catch((e) => {
                throw (this.close(), e);
            });
    }
    quickSearchTrendingClick(e) {
        window.location = e.currentTarget.getAttribute("href");
    }
}
customElements.define("predictive-search", PredictiveSearch);
